import React from 'react';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router';
import { ProfileTabs } from './data';
import { useTranslation } from 'react-i18next';
import { disabledBonusTab } from '../../../enums/MenuItems';
import useToast from '../../../hooks/useToast';

export default function BonusTab({ activeTab, setActiveTab, groupId, isGameGroup }) {
  const { t } = useTranslation();
  const { infoToast } = useToast();

  const handleChange = (_, newValue) => setActiveTab(newValue);
  const location = useLocation();
  const search = location.search;

  return (
    <Box mt={1} sx={{ mt: 1, backgroundColor: (theme) => theme.palette.grey[100] }}>
      <Box justifyContent={'start'} display="flex">
        <Tabs value={activeTab} onChange={handleChange} variant="scrollable" scrollButtons="auto">
          {ProfileTabs.map((tab) => {
            // дисейбл, если узловая группа и некоторые табы
            const isDisable = disabledBonusTab(!isGameGroup, tab.id);

            return isDisable ? (
              <Box
                sx={{ minHeight: '50px', opacity: 0.5, cursor: 'pointer' }}
                display={'flex'}
                alignItems={'center'}
                px={1}
                gap={1}
                onClick={() =>
                  infoToast('The settings for this bonus are only available in the game group.')
                }>
                {tab.icon}
                <Typography>{t(tab.label)}</Typography>
              </Box>
            ) : (
              <Tab
                iconPosition="start"
                label={t(tab.label)}
                sx={{ minHeight: '50px' }}
                icon={tab.icon}
                component={Link}
                to={`/bonuses/${tab.id}/${groupId}${search}`}
                value={tab.id}
                key={tab.label}
              />
            );
          })}
        </Tabs>
      </Box>
    </Box>
  );
}
